import { useApp } from '@k3/core'
import {
  InitialConfiguratorRightsState,
  setUserRights,
} from '../../store/rights/configuratorRights'
import { useVerandaDispatch } from '../..'

export const useSetConfiguratorRights = () => {
  const app = useApp()
  const dispatch = useVerandaDispatch()
  const product = app.product
  if (!product) {
    console.warn('APP.PRODUCT NOT SET!')
    return
  }

  const userRights = userRightsForProduct(product as productType)
  dispatch(setUserRights(userRights))
}

type productType =
  | 'veranda-free'
  | 'veranda-basic'
  | 'veranda-pro'
  | 'veranda-enterprise'
  | 'free'
  | 'basic'
  | 'pro'
  | 'enterprise'

const userRightsForProduct = (
  product: productType
): InitialConfiguratorRightsState => {
  switch (product) {
    case 'veranda-free':
      return {
        nightMode: false,
        individualHouse: false,
      }
    case 'veranda-basic':
      return {
        nightMode: false,
        individualHouse: false,
      }
    case 'veranda-pro':
      return {
        nightMode: false,
        individualHouse: false,
      }
    case 'veranda-enterprise':
      return {
        nightMode: true,
        individualHouse: true,
      }
    case 'free':
      return {
        nightMode: false,
        individualHouse: false,
      }
    case 'basic':
      return {
        nightMode: false,
        individualHouse: false,
      }
    case 'pro':
      return {
        nightMode: false,
        individualHouse: false,
      }
    case 'enterprise':
      return {
        nightMode: true,
        individualHouse: true,
      }
  }
}
